<template>
  <div class="question-item">
    <div class="q-title">{{ index + 1 }}、{{ question.question }}</div>
    <template v-for="(item, index) in answers">
      <div
        @click="selectAnswer(index)"
        class="anwser-item"
        v-if="item"
        :key="index"
        :class="{
          selected: btnStatus.type == 0 && selectIndex === index,
          right: btnStatus.type == 1 && rightIndex === index,
          error:
            btnStatus.type == 1 &&
            selectIndex === index &&
            rightIndex !== index,
        }"
      >
        {{ item }}
      </div>
    </template>
    <div
      style="
        font-size: 3vw;
        text-align: right;
        font-weight: lighter;
        margin-top: 12px;
      "
    >
      (本题来自川观新闻网友：<span style="color: #CB3631"
        >@{{ question.aurthor }}</span
      >)
    </div>
    <div class="ctrls" v-if="selectIndex !== undefined">
      <button class="btn btn-qi" @click="onBtnClick">
        {{
          btnStatus.type == 1 && maxLength === index + 1
            ? "完成答题"
            : btnStatus.text
        }}
      </button>
    </div>
  </div>
</template>

<script>
const BTN_STATUS = [
  {
    type: 0,
    text: "确定",
  },
  {
    type: 1,
    text: "下一题",
  },
];
const mapIndex = {
  A: 0,
  B: 1,
  C: 2,
  D: 3,
};

export default {
  data() {
    return {
      selectIndex: undefined,
      rightIndex: undefined,
      btnStatus: BTN_STATUS[0],
    };
  },
  props: {
    question: {
      type: Object,
      require: true,
    },
    index: {
      type: Number,
      require: true,
    },
    maxLength: {
      type: Number,
      require: true,
    },
  },
  methods: {
    selectAnswer(index) {
      if (this.btnStatus.type < 1) {
        this.selectIndex = index;
      }
    },
    onBtnClick() {
      if (this.btnStatus.type == 0) {
        this.calcResult();
        this.btnStatus = BTN_STATUS[1];
      } else if (this.btnStatus.type == 1) {
        if (this.maxLength == this.index + 1) {
          this.$emit("finish", {
            index: this.index,
            result: this.selectIndex == this.rightIndex,
          });
        } else {
          this.$emit("next", {
            index: this.index,
            result: this.selectIndex == this.rightIndex,
          });
        }
      }
    },
    calcResult() {
      this.rightIndex = mapIndex[this.question.answer];
    },
  },
  computed: {
    answers() {
      return [
        this.question.A,
        this.question.B,
        this.question.C,
        this.question.D,
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.ctrls{
  margin-top: 5vw;
}
.question-item {
  .q-title {
    text-align: left;
    margin-bottom: 10px;
    font-size: 4vw;
    font-weight: bold;
  }

  .btn-qi {
    height: 60px;
    font-size: 30px;
  }
  .anwser-item {
    text-align: left;
    min-height: 45px;
    border: 1px solid #eee;
    margin-bottom: 10px;
    display: flex;
    font-size: 4.5vw;
    justify-content: flex-start;
    align-items: center;
    padding: 5px 10px 5px 4.5vw;
    position: relative;
    border-radius: 5px;
    background-position: center right;
    background-repeat: no-repeat;
    background-size: 30px 30px;
    &.right {
      background-color: #32b16c;
      color: #fff;
      background-image: url("https://cbgccdn.thecover.cn/@/images/20210525/1621936389865090533.png");
    }
    &.error {
      background-color: #ad3230;
      color: #fff;
      background-image: url("https://cbgccdn.thecover.cn/@/images/20210525/1621936396526005144.png");
    }
    &.selected {
      background: #ad3230;
      color: #fff;
    }
    &::before {
      display: block;
      color: #fce4a7;
      font-weight: bold;
      position: absolute;
      left: -10px;
      top: 0;
      font-size: 4.5vw;
      text-shadow: 1px 1px 1px salmon;
    }
    &:nth-of-type(2)::before {
      content: "A";
    }
    &:nth-of-type(3)::before {
      content: "B";
    }
    &:nth-of-type(4)::before {
      content: "C";
    }
    &:nth-of-type(5)::before {
      content: "D";
    }
  }
}
</style>